import { useState } from 'react';
import { useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import axios from 'axios';
import './upload.css';

export default function Upload(props) {
    const [files, setFiles] = useState([]);
    const [fileStatus, setFileStatus] = useState('');

    let url = 'https://atci.lkm.qa.accenture.com/qa-apis/';

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    let ipsLoggedInEnterpriseId = '';
    if (activeAccount) {
        ipsLoggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
    }

    const handleChange = (e) => {        
        for(let file of e.target.files)            
            setFiles(prevFiles => [...prevFiles, file]);
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();
        for(let file of files)
            formData.append('file', file);        
        formData.append('enterprise_id', ipsLoggedInEnterpriseId);
        formData.append('doc_path', props.folderPath);
        formData.append('archive_status', props.archiveStatus);

        if (process.env.NODE_ENV === 'development') {
            url = 'http://localhost:3021';
            // alert(`you are not allowed to upload a file from development environment.`);
            // return;
        }

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
                'Authorization': localStorage.getItem("token"),
                // 'Content-Type': 'application/json'
            },
        };
        axios.post(
            url,
            formData,
            config
        )
            .then(res => {
                props.getAllDocuments();
                setFileStatus(res.data.message);
                setFiles([]);
                setTimeout(() => {
                    setFileStatus('');
                }, 2000)
            })
            .catch(err => console.log(err))
    }

    return (
        <form onSubmit={handleSubmit} className="track-file-upload-form">
            {props.disable == "false" ? <input type="file" onChange={handleChange} id="track-file" multiple hidden /> : null}
            <label for="track-file" className={props.disable == "true" ? 'track-file-upload-label-disable' : 'track-file-upload-label'}>
                {files.length >= 1 ? (files.length === 1 ? files[0].name : `${files.length} files added`) : <div className='track-choose-file-content'>
                    <img src={process.env.PUBLIC_URL + "/images/Track/upload.png"} alt="upload" />
                    <span>Choose file</span>
                </div>}
            </label>
            {files.length >= 1 && fileStatus === '' && <button type="submit" className='track-file-upload-btn'>
                <img src={process.env.PUBLIC_URL + "/images/Track/upload.png"} alt="upload" />
                <span className='track-file-upload-btn-text'>Upload</span>
            </button>}
            {fileStatus && <span className='track-upload-file-status'>{fileStatus}</span>}
        </form>
    )
}